document.addEventListener('DOMContentLoaded', function () {
  var burger = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      nav.classList.toggle('nav-open');
    });
  }

  var tabButtons = document.querySelectorAll('[data-tab-btn]');
  if (tabButtons.length) {
    var panels = document.querySelectorAll('[data-tab-panel]');
    var links = document.querySelectorAll('[data-tab-link]');
    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-btn');
        tabButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-tab-panel') !== target;
        });
        links.forEach(function (a) {
          if (a.getAttribute('data-tab-link') === target) {
            a.hidden = false;
          } else {
            a.hidden = true;
          }
        });
      });
    });
  }
});
